import css from './checkbox.module.css'

interface IProps {
  checked: boolean
  name: string
  onChange: (checked: boolean, name: string) => void
  autoFocus?: boolean
  inscription?: string
}

const Checkbox = (props: IProps) => {
  const handleChange = (e) => {
    const checked = e.target.checked
    props.onChange(checked, props.name)
  }

  return (
    <div className={css.wrapper}>
      <input className={css.input} type="checkbox" checked={props.checked} onChange={handleChange} />
      {props.inscription && <span className={css.inscription}>{props.inscription}</span>}
    </div>
  )
}

export default Checkbox
